/**
 * Created by milky on 2017/6/20.
 */
export default {
  getMenuStartTime: state => state.menuStartTime,
  getMenuEndTime: state => state.menuEndTime,
  // user info
  getUserId: state => state.userId,
  getToken: state => state.token,
  getRoleType: state => state.roleType,
  getAccount: state => state.account,
  getBrandId: state => state.brandId,
  getStoreId: state => state.storeId,
  getBrands: state => state.brands,
  getStores: state => state.stores,
  // update data
  getUpCategory: state => state.upCategory,
  getUpAdjust: state => state.upAdjust,
  // modal open
  getModal: state => state.modal,
  // lineNotifyTable
  getSelManagerId: state => state.selManagerId,
  getSelRoleType: state => state.selRoleType,
  getModalView: state => state.modalView,
  // blackReason
  getBlackReason: state => state.blackReason,
  // 取餐方式
  getPickupType: state => state.pickupList,
  // notify
  getUnReadNotify: state => state.unReadNotify,
  getTradeType: state => state.tradeType,
  getEtradeType: state => state.tradeType.filter(x => x.value !== 1),
  getECtradeType: state => state.tradeType.filter(x => x.value !== 1 && x.value !== 999),
  // 抽成系統開通權限
  getRestricted: state => state.restrictedList,
  getDenyList: state => state.denyList,
  // 縣市列表
  getCityOption: state => state.cityList.map(city => {
    return {
      name: city.name,
      code: city.city_code
    }
  }),
  // 你訂聯盟
  getNidinLeague: state => state.nidin_league
}



// WEBPACK FOOTER //
// ./src/store/getters.js